export const FAQ_MAX_ITEMS = 20;
export const FAQ_HEADER_MAX_LENGTH = 150;
export const FAQ_TEXT_MAX_LENGTH = 2000;
